module.exports = __webpack_public_path__ + "static/media/favicon.8a3f84dd.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 347
// module chunks = 0